<template>
  <div class="text-sm text-secondary">
    <div v-if="date" class="flex flex-wrap items-center gap-x-4 gap-y-2">
      <span class="uppercase tracking-wide">{{ formatDate(date) }}</span>
      <span v-if="cypressVersion" class="inline-flex items-center gap-1 border border-border px-2 py-0.5">
        <IconCypress class="w-4" /> {{ cypressVersion }}
      </span>
      <span v-if="playwrightVersion" class="inline-flex items-center gap-1 border border-border px-2 py-0.5">
        <IconPlaywright class="w-4" /> {{ playwrightVersion }}
      </span>
      <span v-if="vitestVersion" class="inline-flex items-center gap-1 border border-border px-2 py-0.5">
        <IconVitest class="w-4" /> {{ vitestVersion }}
      </span>
      <span v-if="webdriverioVersion" class="inline-flex items-center gap-1 border border-border px-2 py-0.5">
        <IconWebdriverio class="w-4" /> {{ webdriverioVersion }}
      </span>
      <span v-if="cursorVersion" class="inline-flex items-center gap-1 border border-border px-2 py-0.5">
        <IconCursor class="w-4" /> {{ cursorVersion }}
      </span>
    </div>
    <div v-if="readingTime" class="mt-2 uppercase tracking-wide">
      {{ readingTime }}
    </div>
    <ViewCounter :slug="route.path" />
  </div>
</template>
<script setup lang="ts">
import { formatDate } from '@/helpers/formatDate'

const route = useRoute()

defineProps({
  date: {
    type: String,
    default: ''
  },
  cypressVersion: {
    type: String,
    default: ''
  },
  playwrightVersion: {
    type: String,
    default: ''
  },
  cursorVersion: {
    type: String,
    default: ''
  },
  vitestVersion: {
    type: String,
    default: ''
  },
  webdriverioVersion: {
    type: String,
    default: ''
  },
  readingTime: {
    type: String,
    default: ''
  }
})
</script>
